<template>
  <div class="audio-player">
    <v-btn
      @click.stop="togglePlay"
      icon
      flat
      small>
      <v-icon v-if="isPlaying">pause_circle_filled</v-icon>
      <v-icon v-else>play_circle_filled</v-icon>
    </v-btn>

    <app-slider
      v-show="loadeddata && hasDuration && currentTime"
      :hide-details="true"
      class="time-slider"
      color="black"
      v-model="currentTime"
      @start="isSeeking = true"
      @end="isSeeking = false"
      @sliderClick="onSliderClick"
      :max="duration"
      :min="0"
      :step="0.01"/>

    <span v-show="currentTime" class="time-text">
      {{currentTime | time}}
      <!-- <template v-if="hasDuration">
        / {{duration | time}}
      </template> -->
    </span>

    <audio ref="audio" preload="auto">
      <source :src="audioObjectUrl" :type="blob.type">
    </audio>
  </div>
</template>

<script>


export default {
  data() {
    return {
      duration: null,
      isPlaying: false,
      isSeeking: false,
      loadeddata: false,
      currentTime: null,
      audioObjectUrl: null
    };
  },

  props: {
    blob: {
      type: [Blob, File],
      required: true
    }
  },

  computed: {
    hasDuration() {
      return typeof this.duration === 'number' && this.duration !== Infinity;
    }
  },

  watch: {
    isSeeking(v) {
      if (v) {
        this._audio.pause();
      } else {
        this._audio.currentTime = this.currentTime;
        this._audio.play();
      }
    }
  },

  filters: {
    time(totalSeconds) {
      if (typeof totalSeconds !== 'number') {
        return '';
      }
      let minutes = Math.floor(totalSeconds / 60);
      let seconds = Math.round(totalSeconds % 60);
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return `${minutes}:${seconds}`;
    }
  },

  mounted() {
    this._audio = this.$refs.audio;
    // media events:
    // https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Media_events

    // HTMLAudioElement:
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement
    this._audio.addEventListener('pause', this.onPause.bind(this));
    this._audio.addEventListener('playing', this.onPlaying.bind(this));
    this._audio.addEventListener('loadeddata', this.onLoadeddata.bind(this));
    this._audio.addEventListener('timeupdate', this.onTimeupdate.bind(this));
    this._audio.addEventListener('durationchange', this.onDurationchange.bind(this));

    this.audioObjectUrl = URL.createObjectURL(this.blob);
    // this._audio.load();
    // this._audio.addEventListener('seeked', e => );
    // this._audio.addEventListener('seeking', e => );
    // this._audio.addEventListener('suspend', e => log.info('suspend', e));
  },

  beforeDestroy() {
    URL.revokeObjectURL(this.audioObjectUrl);
  },

  methods: {
    togglePlay() {
      if (this.isPlaying) {
        this._audio.pause();
      } else {
        this._audio.play();
      }
    },

    onPause() {
      this.isPlaying = false;
    },

    onPlaying() {
      this.isPlaying = true;
    },

    onDurationchange() {
      window.audio = this._audio;
      this.duration = this._audio.duration || 0;
    },

    onTimeupdate() {
      this.currentTime = this._audio.currentTime;
    },

    onLoadeddata() {
      this.loadeddata = true;
      this.duration = this._audio.duration;
      this.currentTime = this._audio.currentTime;
    },

    onSliderClick(value) {
      this._audio.currentTime = value;
      this._audio.play();
    }
  }
};
</script>

<style lang="stylus" scoped>
.audio-player {
  display: flex;
  align-items: center;
}

.time-slider {
  // flex-grow: 1;
  padding: 0 0.5rem 0 0.5rem;
  margin: 0 auto 0 auto;
  max-width: 6rem;
}

.time-text {
  font-size: 1rem;
  flex-shrink: 0;
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
